import { NotFound } from "@bisom/web_package";

import PublicLayout from "@/layouts/public.vue";
import BilanPage from "@/pages/Bilan.vue";

const routes = [
  {
    path: "/",
    redirect: { name: "bilan" },
  },
  {
    path: "/public",
    component: PublicLayout,
    children: [
      {
        path: "Bilan",
        name: "bilan",
        component: BilanPage,
      },
    ],
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/init/available",
  },
];

export default routes;
